import React, { useState } from 'react';
// @ts-ignore
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../Assets/css/FlotaHome.css';
import { NextArrow, PrevArrow } from "./ui/CustomArrow";

import Flota from '../Assets/img/flota/web-Irizar_i6.jpg';
import Flota2 from '../Assets/img/flota/web-Comil_Invictus1050.jpg';
import Flota3 from '../Assets/img/flota/web-MercedesBenz_Sprinter.jpg';
import Flota4 from '../Assets/img/flota/web-MP_Viaggio1050.jpg';

import pdf from '../Assets/img/flota/Ficha_Irizari6.pdf';
import pdf2 from '../Assets/img/flota/Ficha_Invictus1050.pdf';
import pdf3 from '../Assets/img/flota/Ficha_Sprinter.pdf';
import pdf4 from '../Assets/img/flota/Ficha_Viaggio1050.pdf';

const FlotaArray = [
    { imagen: Flota, url: pdf, name: 'Irizar i6' },
    { imagen: Flota2, url: pdf2, name: 'Comil Invictus 1050' },
    { imagen: Flota3, url: pdf3, name: 'Mercedes-Benz Sprinter' },
    { imagen: Flota4, url: pdf4, name: 'Marcopolo Viaggio 1050' }
];

export const Flotabuses = () => {

    const [buses, setBuses] = useState(FlotaArray);

    const sliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <section className="flota-container" id="flota">
            <div className="container">
                <h1
                    style={{
                        textAlign: 'center',
                        fontSize: '50px',
                        paddingBottom: '10px',
                        fontWeight: 'bold'
                    }}
                >
                    Nuestra Flota
                </h1>

                <div className="slider-flota-container">
                    <Slider {...sliderSettings}>
                        {buses.map((flota, index) => (
                            <div className="cubo-flota" key={index}>
                                <a href={flota.url} target="_blank" rel="noopener noreferrer">
                                    <div className="flota-image-container">
                                        <img
                                            className="cliente-logo"
                                            src={flota.imagen}
                                            alt={flota.imagen}
                                        />
                                        <h3 className="flota-name">{flota.name}</h3>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

